import React, { FC, useCallback, useState } from "react";

import classNames from "classnames";

import { useAdminResetUserPasswordMutation } from "@api/graphql";

import styles from "./ResetPasswordButton.module.scss";

interface ResetPasswordButtonProps {
  userId: string;
}

export const ResetPasswordButton: FC<ResetPasswordButtonProps> = ({ userId }) => {
  const [buttonText, setButtonText] = useState("Reset Password");

  const [adminResetUserPasswordMutation, { loading }] = useAdminResetUserPasswordMutation({
    variables: {
      input: {
        user_name: userId,
      },
    },
    onCompleted: () => {
      setButtonText("Sent Successfully!");

      // Reset button text after 3 seconds
      setTimeout(() => {
        setButtonText("Reset Password");
      }, 3000);
    },
    onError: () => {
      setButtonText("Reset Password");
    },
  });

  const handleResetPasswordClicked = useCallback(() => {
    adminResetUserPasswordMutation();
  }, [adminResetUserPasswordMutation]);

  return (
    <span className={classNames(styles["reset-password-button"], "b3 bold")} onClick={handleResetPasswordClicked}>
      {loading && <span className="spinner-border spinner-border-sm me-2" />}
      {buttonText}
    </span>
  );
};
